import { combineReducers } from "redux";
// Reducer
import auth from "./reducer/admin.reducer";
import usuarios from "./reducer/usuario.reducer";
import mensajeria from './reducer/mensajeria.reducer'


const ROOT_REDUCER = combineReducers({
  auth,
  usuarios,
  mensajeria
});

export default ROOT_REDUCER;
